<div class="flex flex-col h-full overflow-hidden">
  <div class="z-50 bg-white">
    <app-header />
  </div>

  <div #contentContainer class="flex-1 min-h-0">
    <div class="flex flex-row h-full">
      <div class="flex-1 min-w-0">
        <router-outlet />
      </div>
    </div>
  </div>
</div>
